<template>
  <div id="bsczhu2">
    <div class="box">
      <div id="bsczhu2div" style="float:left;width:45%;height:99%;"></div>
      <div id="bsczhu3div" style="float:left;width:45%;height:99%;"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";
import request from '@/utils/request'
export default {
  name: "bsczhu2",
  data1: [],
  data2: [],
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [[-10, 5, -3]],
      NowYearTargetValue: ["内饰", "外饰", "AYM"],
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
  },
  methods: {
    refreshChart(chartData) {
      var myChart = echarts.init(document.getElementById("bsczhu2div"));
      var myChart3 = echarts.init(document.getElementById("bsczhu3div"));
      if (chartData === undefined) {
        myChart.clear();
        myChart3.clear();
        return;
      }
       this.data1=chartData[0];
       this.data2=chartData[1];
      var option = {
        title: {
          text: this.locale('Save energy(tce)','节能量(吨标煤)'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: "left",
          y: 5
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        color: [
          "#87CDEB",
          "#5FBCE4",
          "#40AFDF",
          "#239DD1",
          "#1E86B3",
          "#186B8F",
        ],
        series: [
          {
            type: "pie",
            name: this.locale('Save energy(tce)','节能量(吨标煤)'),
            radius: "60%",
            center: ["50%", "60%"],
            selectedMode: "single",
            data: this.data1,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
                normal: {
                    textStyle : {
                        fontSize: 16
                    }
                }
            },
            itemStyle: {
              normal: {
                label: {
                  formatter: function (p) {
                    return (
                      p.data.name +":" + p.data.value
                    );
                  },
                },
              }
            },
          },
        ],
      };
      var option3 = {
        title: {
          text: this.locale('Costing reduce(¥10K)','降本数(万元)'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: "right",
          y: 5
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        color: [
          "#87CDEB",
          "#5FBCE4",
          "#40AFDF",
          "#239DD1",
          "#1E86B3",
          "#186B8F",
        ],
        series: [
          {
            type: "pie",
            name: this.locale('Costing reduce(¥10K)','降本数(万元)'),
            radius: "60%",
            center: ["50%", "60%"],
            selectedMode: "single",
            data: this.data2,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
                normal: {
                    textStyle : {
                        fontSize: 16
                    }
                }
            },
            itemStyle: {
              normal: {
                label: {
                  formatter: function (p) {
                    return (
                      p.data.name +":" +p.data.value
                    );
                  },
                },
              }
            },
          },
        ],
      };
      // 5：展示数据
      myChart.setOption(option);
      myChart3.setOption(option3);
    },
  },
};
</script>

<style lang="less" >
#bsczhu2 {
  position: relative;
  width: 99%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  // margin-left: 10px;
  margin-top: 10px;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
